export const localization = () =>{
    return(
        {
            th:{
                myShopDataHeader:'ร้านของฉัน',
                anonymousMode:'โหมดผู้ใช้งานทั่วไป',
                editorMode:'โหมดแก้ไขข้อมูล',
                pinButton:'ปักหมุดร้านของฉัน',
                findButton:'ค้นหาร้านใกล้ฉัน',
                createNewShop:'สร้างข้อมูลร้านใหม่',
                shopName:'ชื่อร้าน',
                shopAddress:'ที่อยู่',
                shopDetail:'รายละเอียดเพิ่มเติม',
                shopPhone:'เบอร์โทร',
                shopQuantity:'จำนวนสินค้า',
                shopPrice:'ราคาต่อชิ้น',
                shopFacebook:'Facebook',
                shopLine:'Line Id',
                shopProductPic:'ภาพสินค้า',
                shopProductType:'ชนิดสินค้า',
                findShopHeader:'ค้นหาร้าน',
                findShopInputPlaceHolder:'ค้นหาจากชื่อร้าน',
                menuLoginFooterString:'*สำหรับร้านที่ต้องการแชร์ข้อมูลกรุณา Log in',
                lowerTxt:'ราคาต่ำสุด',
                higherTxt:'สินค้าเยอะสุด',
                callButton:'โทร',
                directionButton:'ดูเส้นทาง',
                callTxt:'เบอร์โทร',
                shopTxt:'ร้าน',
                stockInfo:'ข้อมูล สินค้า',
                shopInfo:'ข้อมูล ร้าน',
                locationInfo:'ข้อมูล พิกัด',
                updateShopInfo:'อัพเดทข้อมูลร้าน',
                shopId:'รหัสร้าน',
                sponsorTxt:'ผู้สนับสนุน',
                normalMask:'หน้ากากอนามัย',
                n95mask:'หน้ากาก N95',
                filter:'แผ่นกรอง',
                cottonMask:'หน้ากากผ้า',
                alcGel:'เจลล้างมือ',
                allType:'ทั้งหมด',
                priceUnit:'บ.',
                quantityUnit:'ชิ้น',
                joinSponsor:'เลี้ยงกาแฟ',
                bigSponsorTxt:'ขอเป็นผู้สนับสนุน',
                donateResultTxt:'ยอดบริจาค',
                costResultTxt:'ค่าใช้จ่าย',
                missingValuesTxt:'กรุณาระบุข้อมูล!',
                updateAtTxt:'อัพเดทข้อมูลล่าสุดเมื่อ', 
                issueReport:'รายงาน',
                verifyBtn:'ยืนยันร้าน',
                verifyDetail:'การยืนยันร้านจะใช้วิธี ให้ผู้ที่ทำการ Log in เข้ามาช่วยกันกดยืนยัน 5 คนขึ้นไป หากร้านกระทำความผิด หรือถูก report ผู้ที่เข้ามายืนยันร้านจะถูกหักคะแนนความน่าเชื่อถือด้วย (คล้ายๆการค้ำประกัน) หากถูก report 5 ครั้ง ร้านจะถูกลบออกจากระบบ หากกดซ้ำก็ยังนับเป็นผู้ยืนยันคนเดิม ไม่นับคะแนนยืนยันเพิ่ม',
                cannotVerify:'กรุณา Log in ก่อนเข้าร่วมการช่วยยืนยันร้าน',
                sponsorDetailTxt:'โปรเจคนี้เป็นโปรเจคแบบ ไม่แสวงผลกำไร เปิดให้ทุกคนได้ใช้ฟรี ไม่มีข้อแม้ แต่เนื่องจากมีผู้ใช้งานเป็นจำนวนมาก จึงมีค่าใช้จ่ายด้าน server ตามมา เพื่อให้โปรเจคนี้ยังสามารถให้ทุกคนได้ใช้งานต่อไปได้ ผู้พัฒนาจึงเปิดให้ทุกคน สามารถร่วมสนับสนุนโครงการด้วยการบริจาค 5 บาท 10 บาทตามกำลัง โดยยอดเงินหลังจากหักค่าใช้จ่ายแล้ว จะมอบให้การกุศลต่อไป ขออนุโมทนาและขอให้ผ่านวิกฤติครั้งนี้ไปด้วยกัน',
            },
            en:{
                myShopDataHeader:'My Shop Data',
                anonymousMode:'User mode',
                editorMode:'Editor Mode',
                pinButton:'Pin My Shop',
                findButton:'Find Nearby Me',
                createNewShop:'Create New Shop',
                shopName:'Shop Name',
                shopAddress:'Address',
                shopDetail:'More Details',
                shopPhone:'Phone',
                shopQuantity:'Quantity',
                shopPrice:'Price',
                shopFacebook:'Facebook',
                shopLine:'Line Id',
                shopProductPic:'Product Pic',
                shopProductType:'Product Type',
                findShopHeader:'Find Shop',
                findShopInputPlaceHolder:'Find by name',
                menuLoginFooterString:'*For Submit data to our system please Log in',
                lowerTxt:'Lower Price',
                higherTxt:'Higher Quantity',
                callButton:'Call',
                directionButton:'Get Direction',
                callTxt:'Phone',
                shopTxt:'Shop',
                stockInfo:'Product Info.',
                shopInfo:'Shop Info.',
                locationInfo:'Location Info.',
                updateShopInfo:'Update Shop Data',
                shopId:'Shop Id',
                sponsorTxt:'Sponsor',
                normalMask:'Mask',
                n95mask:'N95',
                filter:'Filter',
                cottonMask:'Cotton Mask',
                alcGel:'Alcohol Gel',
                allType:'All Type',
                priceUnit:'$',
                quantityUnit:'pcs.',
                joinSponsor:'Donate',
                sponsorDetailTxt:'',
                bigSponsorTxt:'Become a Sponsor',
                donateResultTxt:'Fund',
                costResultTxt:'Cost',
                missingValuesTxt:'Please filling information!',
                updateAtTxt:'Updated At',
                issueReport:'Report',
                verifyBtn:'Verify Shop',
                verifyDetail:'การยืนยันร้านจะใช้วิธี ให้ผู้ที่ทำการ Log in เข้ามาช่วยกันกดยืนยัน 5 คนขึ้นไป หากร้านกระทำความผิด หรือถูก report ผู้ที่เข้ามายืนยันร้านจะถูกหักคะแนนความน่าเชื่อถือด้วย (คล้ายๆการค้ำประกัน) หากถูก report 5 ครั้ง ร้านจะถูกลบออกจากระบบ หากกดซ้ำก็ยังนับเป็นผู้ยืนยันคนเดิม ไม่นับคะแนนยืนยันเพิ่ม',
                cannotVerify:'Please log in before verify',
                sponsorDetailTxt:'โปรเจคนี้เป็นโปรเจคแบบ ไม่แสวงผลกำไร เปิดให้ทุกคนได้ใช้ฟรี ไม่มีข้อแม้ แต่เนื่องจากมีผู้ใช้งานเป็นจำนวนมาก จึงมีค่าใช้จ่ายด้าน server ตามมา เพื่อให้โปรเจคนี้ยังสามารถให้ทุกคนได้ใช้งานต่อไปได้ ผู้พัฒนาจึงเปิดให้ทุกคน สามารถร่วมสนับสนุนโครงการด้วยการบริจาค 5 บาท 10 บาทตามกำลัง โดยยอดเงินหลังจากหักค่าใช้จ่ายแล้ว จะมอบให้การกุศลต่อไป ขออนุโมทนาและขอให้ผ่านวิกฤติครั้งนี้ไปด้วยกัน',
            }
        }
    )
}